export default __webpack_public_path__ + "96eea6af55c76881361f9df7d33e7dd7.png";